import React from 'react';

import styles from './Error.module.scss';

type ErrorProps = {
  error: string | Error;
  className: string;
};

const replaceContactSupport = (errorMessage: string) => {
  return errorMessage.replace(
    /contact support/g,
    `<a href="https://support.tempo.fit/contact/contact-us-ByRoFp10w" style="text-decoration: underline">
      contact support
    </a>`
  );
};

const errorMessageMapper = (errorMessage: string): string => {
  const errorsMap: { [key: string]: string } = {
    'Invalid subscription credit claim code':
      'Sorry there was an issue with your gift code. Try again or Contact Support at (415) 964-2975',
  };

  if (errorsMap[errorMessage]) {
    return errorsMap[errorMessage];
  }

  return errorMessage;
};

export const Error = ({ error, className }: ErrorProps) => {
  let message = typeof error === 'string' ? error : error.message;

  if (!message) {
    message = 'An unexpected error has occurred.';
  }

  message = replaceContactSupport(message);
  message = errorMessageMapper(message);

  return (
    <div className={`${styles.errors} ${className ? className : ''}`}>
      {message && (
        <div
          className={styles.item}
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        ></div>
      )}
    </div>
  );
};

